module.exports = __webpack_public_path__ + "static/media/login-background.2680e848.png";